export const ALL_MODULES = [
  { id: 'dashboard', label: 'Dashboard', category: 'Principal' },

  { id: 'ventas-pos', label: 'Punto de Venta', category: 'Ventas' },
  { id: 'ventas-profesional', label: 'Ventas Profesional', category: 'Ventas' },
  { id: 'ventas-historial', label: 'Historial Ventas', category: 'Ventas' },
  { id: 'devoluciones', label: 'Devoluciones', category: 'Ventas' },
  { id: 'caja', label: 'Caja', category: 'Ventas' },
  // Permiso fino, no es una pantalla: habilita el historial de cierres, el
  // detalle del arqueo y los importes teorico/diferencia cuando la organizacion
  // tiene el cierre ciego activo. Ver utils/cashCloseVisibility.js.
  // `permissionOnly` lo deja fuera de los presets de plan y del onboarding por
  // modulo: no hay pantalla que presentar y su disponibilidad se resuelve por
  // alias contra `caja` (MODULE_ORG_ALIAS_MAP).
  { id: 'caja-cierre-completo', label: 'Caja: Ver Cierre Completo', category: 'Ventas', permissionOnly: true },
  // Permisos finos de Caja, del mismo tipo: no son pantallas, solo aplican con
  // el cierre ciego activo. Ver utils/cashCloseVisibility.js.
  { id: 'caja-ver-movimientos', label: 'Caja: Ver Movimientos del Turno', category: 'Ventas', permissionOnly: true },
  { id: 'caja-ver-ultimos-movimientos', label: 'Caja: Ver Ultimos Movimientos', category: 'Ventas', permissionOnly: true },
  { id: 'caja-imprimir-cierre', label: 'Caja: Imprimir Arqueo', category: 'Ventas', permissionOnly: true },
  { id: 'caja-anular-movimiento', label: 'Caja: Anular Movimientos', category: 'Ventas', permissionOnly: true },
  // Permiso fino del POS: aplicar descuento por producto por encima del tope de
  // la empresa, sobre productos "sin descuentos", y autorizar el de otro cajero.
  // Admin/administrador lo tienen siempre. Ver utils/descuentoItem.js.
  { id: 'ventas-pos-descuento-autorizar', label: 'POS: Autorizar descuentos', category: 'Ventas', permissionOnly: true },
  { id: 'clientes', label: 'Clientes', category: 'Ventas' },
  { id: 'facturacion', label: 'Facturacion', category: 'Ventas' },
  // Permiso fino: cargar desde Facturacion una venta a cuenta corriente que no
  // entra al arqueo de caja y con stock opcional. Admin/administrador lo tienen
  // siempre. Ver utils/ventaAdministrativa.js.
  { id: 'facturacion-venta-administrativa', label: 'Facturacion: Venta Administrativa', category: 'Ventas', permissionOnly: true },
  // Depende funcionalmente de 'facturacion': solo se puede acreditar lo que se
  // facturó. Se deja como módulo aparte para poder dar facturación sin dar la
  // facultad de emitir notas de crédito, que es plata que se licua.
  { id: 'notas-credito', label: 'Notas de Credito', category: 'Ventas' },
  { id: 'presupuestos', label: 'Presupuestos', category: 'Ventas' },
  { id: 'listas-precios', label: 'Listas de Precios', category: 'Ventas' },

  { id: 'crm-dashboard', label: 'CRM Mi Panel', category: 'CRM' },
  { id: 'crm-mi-semana', label: 'CRM Mi Semana', category: 'CRM' },
  { id: 'crm-triaje', label: 'CRM Triaje', category: 'CRM' },
  { id: 'crm-proyectos', label: 'CRM Proyectos', category: 'CRM' },
  { id: 'crm-banco-horas', label: 'CRM Banco de Horas', category: 'CRM' },
  { id: 'crm-tickets', label: 'CRM Tickets', category: 'CRM' },
  { id: 'agenda', label: 'CRM Reuniones', category: 'CRM' },
  { id: 'crm-administracion', label: 'CRM Administracion', category: 'CRM' },
  { id: 'crm-acuerdos-facturacion', label: 'CRM Acuerdos y Facturacion', category: 'CRM' },
  { id: 'crm-reportes', label: 'CRM Reportes', category: 'CRM' },
  { id: 'crm-catalogos', label: 'CRM Catalogos', category: 'CRM' },

  { id: 'tienda-config', label: 'Tienda Virtual', category: 'Digital' },
  // Solo la CONFIGURACION de la integracion con Tienda Nube (conectar la cuenta,
  // vincular productos, ver el log de sincronizacion). Los PEDIDOS que llegan de
  // Tienda Nube NO viven aca: entran a 'pedidos-web' junto con los de la tienda
  // nativa, distinguidos por store_orders.channel.
  // Va separado de 'tienda-config' a proposito: el caso tipico es un comercio
  // que ya vende en Tienda Nube y no usa la tienda nativa de Impulza (Memo, por
  // ejemplo, no tiene 'tienda-config'). Atarlo al canal propio dejaba afuera a
  // quien mas lo necesita.
  { id: 'tienda-nube', label: 'Tienda Nube (config)', category: 'Digital' },
  // Canal Mercado Libre: conexión, vinculación de publicaciones, stock/precio
  // y bandeja de ventas que no entraron. Mismo criterio que 'tienda-nube'.
  { id: 'mercado-libre', label: 'Mercado Libre', category: 'Digital' },
  // Canal Rappi: locales, menú vinculado, bandeja de pedidos (aceptar /
  // rechazar) y disponibilidad. Aceptar lo puede hacer quien atiende.
  { id: 'rappi', label: 'Rappi', category: 'Digital' },
  { id: 'pedidos-web', label: 'Pedidos Web', category: 'Digital' },
  { id: 'logistica', label: 'Logistica', category: 'Logistica' },

  { id: 'compras-ocr', label: 'Escaner IA', category: 'Compras' },
  { id: 'compras-nueva', label: 'Nueva Compra', category: 'Compras' },
  { id: 'pedido-sugerido', label: 'Pedido Sugerido', category: 'Compras' },
  { id: 'compras', label: 'Historial Compras', category: 'Compras' },
  { id: 'proveedores', label: 'Proveedores', category: 'Compras' },
  { id: 'importar-lista-proveedor', label: 'Importar Lista Proveedor', category: 'Compras' },
  { id: 'comparador-precios', label: 'Comparador de Precios', category: 'Compras' },
  { id: 'historial-cambios-masivos', label: 'Historial Cambios Masivos', category: 'Compras' },

  { id: 'inventario', label: 'Stock Actual', category: 'Inventario' },
  { id: 'productos', label: 'Productos', category: 'Inventario' },
  { id: 'inventario-transferencia', label: 'Transferencias', category: 'Inventario' },
  { id: 'inventario-ajuste', label: 'Ajustes', category: 'Inventario' },
  { id: 'inventario-movimientos', label: 'Historial Movimientos', category: 'Inventario' },
  { id: 'inventario-etiquetas', label: 'Etiquetas', category: 'Inventario' },

  { id: 'produccion-registrar', label: 'Produccion', category: 'Produccion' },
  { id: 'pedidos-produccion', label: 'Pedidos Produccion', category: 'Produccion' },
  { id: 'recetas', label: 'Recetas', category: 'Produccion' },
  { id: 'produccion-historial', label: 'Historial Prod.', category: 'Produccion' },
  { id: 'produccion-distribucion', label: 'Distribucion Costos', category: 'Produccion' },

  { id: 'reportes-inteligentes', label: 'Reportes Inteligentes', category: 'Finanzas' },
  { id: 'reportes', label: 'Reportes', category: 'Finanzas' },
  { id: 'bancos', label: 'Bancos', category: 'Finanzas' },
  { id: 'tesoreria-cobranzas', label: 'Cobros', category: 'Finanzas' },
  { id: 'tesoreria-pagos', label: 'Pagos', category: 'Finanzas' },
  { id: 'tesoreria-transferencia', label: 'Transf. Tesoreria', category: 'Finanzas' },
  { id: 'gastos', label: 'Gastos', category: 'Finanzas' },
  { id: 'gestion-costos', label: 'Gestion Costos', category: 'Finanzas' },
  { id: 'rentabilidad-ventas', label: 'Rentabilidad', category: 'Finanzas' },
  { id: 'flujo-fondos', label: 'Flujo Fondos', category: 'Finanzas' },
  { id: 'conciliacion-bancaria', label: 'Conciliacion Bancaria', category: 'Finanzas' },
  { id: 'conciliacion-ctas-ctes', label: 'Conciliacion Ctas Ctes', category: 'Finanzas' },
  { id: 'reportes-ctas-ctes', label: 'Cuentas Corrientes', category: 'Finanzas' },
  { id: 'reportes-impositivos', label: 'Reportes Impositivos', category: 'Finanzas' },

  { id: 'chatbot', label: 'IA Asistente', category: 'Sistema' },

  // Community Manager: modulo opt-in. Se lista aca para que SuperAdmin y las
  // pantallas de Usuarios/Roles lo puedan ofrecer, pero queda FUERA de todos los
  // presets de plan (ver filtro por categoria en enterprise): se habilita
  // explicitamente por organizacion.
  { id: 'comunity-manager-dashboard',    label: 'CM Dashboard',    category: 'Community Manager' },
  { id: 'comunity-manager-crear',        label: 'CM Crear post',   category: 'Community Manager' },
  { id: 'comunity-manager-calendario',   label: 'CM Calendario',   category: 'Community Manager' },
  { id: 'comunity-manager-aprobaciones', label: 'CM Aprobaciones', category: 'Community Manager' },
  { id: 'comunity-manager-global',       label: 'CM Vista global', category: 'Community Manager' },

  // Instituto: módulo opt-in. Se habilita explícitamente por organización desde
  // SuperAdmin, igual que Community Manager. Fuera de todos los PLAN_PRESET.
  { id: 'instituto-grilla',     label: 'Instituto - Grilla',       category: 'Instituto' },
  { id: 'instituto-alumnos',    label: 'Instituto - Alumnos',      category: 'Instituto' },
  { id: 'instituto-profesores', label: 'Instituto - Profesores',   category: 'Instituto' },
  { id: 'instituto-cobrar',     label: 'Instituto - Cobrar',       category: 'Instituto' },
  { id: 'instituto-config',     label: 'Instituto - Configuración', category: 'Instituto' },

  // Cobro de abono + onboarding guiado (port Gastify → Impulza).
  // INACTIVOS por defecto: NO se incluyen en ningún PLAN_PRESET. Solo el
  // superadmin los activa por organización (org de prueba). Ver
  // billingBrandConfig.js y useSubscriptionStatus.jsx.
  { id: 'suscripcion-billing', label: 'Cobro de Abono (beta)', category: 'Sistema' },
  { id: 'onboarding-guiado', label: 'Onboarding Guiado (beta)', category: 'Sistema' },

  { id: 'empresa-datos', label: 'Datos Empresa', category: 'Configuracion' },
  { id: 'permisos', label: 'Usuarios y Roles', category: 'Configuracion' },
  { id: 'sitios', label: 'Sucursales/Sitios', category: 'Configuracion' },
  { id: 'categorias', label: 'Categorias', category: 'Configuracion' },
  { id: 'unidades-medida', label: 'Unidades Medida', category: 'Configuracion' },
  { id: 'config-sistema-datos', label: 'Config. General', category: 'Configuracion' },
  { id: 'importaciones', label: 'Importaciones', category: 'Configuracion' },
  { id: 'metodos-cobro', label: 'Metodos de Cobro', category: 'Configuracion' },
  { id: 'condiciones-pago', label: 'Condiciones de Pago', category: 'Configuracion' },
  { id: 'tipos-comprobante', label: 'Tipos Comprobante', category: 'Configuracion' },
  { id: 'presupuestos-config', label: 'Config. Presupuestos', category: 'Configuracion' },
  { id: 'config-logistica', label: 'Config. Logistica', category: 'Configuracion' },
  { id: 'config-facturacion', label: 'Config. Fiscal', category: 'Configuracion' },
  { id: 'config-reportes', label: 'Reportes y Tickets', category: 'Configuracion' },
  { id: 'logs', label: 'Logs de Auditoria', category: 'Configuracion' },
];

export const PLAN_PRESETS = {
  basic: [
    'dashboard', 'ventas-pos', 'ventas-historial', 'caja', 'clientes',
    'productos', 'inventario', 'gastos',
    'empresa-datos', 'sitios', 'categorias', 'metodos-cobro', 'importaciones',
  ],
  premium: [
    'dashboard', 'ventas-pos', 'ventas-historial', 'caja', 'clientes',
    'facturacion', 'notas-credito', 'presupuestos', 'productos', 'inventario',
    'compras-nueva', 'pedido-sugerido', 'compras', 'proveedores', 'bancos', 'gastos',
    'tesoreria-cobranzas', 'tesoreria-pagos', 'compras-ocr',
    'reportes-inteligentes', 'reportes',
    'empresa-datos', 'sitios', 'categorias', 'metodos-cobro', 'condiciones-pago',
    'config-facturacion', 'config-reportes', 'importaciones',
  ],
  enterprise: ALL_MODULES
    .filter((module) => !module.permissionOnly)
    // Community Manager e Instituto nunca entran por plan: son opt-in por organizacion.
    .filter((module) => module.category !== 'Community Manager' && module.category !== 'Instituto')
    .filter((module) => ![
      'logistica', 'config-logistica', 'pedidos-produccion',
      // Modulos nuevos: arrancan apagados en todos los planes y se
      // habilitan por organizacion desde SuperAdmin.
      'importar-lista-proveedor', 'historial-cambios-masivos', 'comparador-precios',
    ].includes(module.id))
    .map((module) => module.id),
};
